import { render } from "./PeriodicFollowTask.vue?vue&type=template&id=40bec4cc&scoped=true&ts=true"
import script from "./PeriodicFollowTask.vue?vue&type=script&lang=ts"
export * from "./PeriodicFollowTask.vue?vue&type=script&lang=ts"

import "./PeriodicFollowTask.vue?vue&type=style&index=0&id=40bec4cc&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/.pnpm/vue-loader@17.4.2_vue@3.3.13_webpack@5.99.5/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40bec4cc"]])

export default __exports__